<!-- Toast notifications -->
<p-toast>
  <ng-template let-message pTemplate="message">
    <div style="display: flex; align-items: flex-start; gap: 0.75rem; width: 100%;">
      <i [class]="'pi pi-' + (message.severity === 'success' ? 'check-circle' : message.severity === 'info' ? 'info-circle' : message.severity === 'warn' ? 'exclamation-triangle' : 'times-circle')"
         style="font-size: 1.5rem; margin-top: 0.25rem;"></i>
      <div style="flex: 1;">
        <div style="font-weight: 600; margin-bottom: 0.5rem;">{{ message.summary }}</div>
        <div [innerHTML]="message.detail"></div>
      </div>
    </div>
  </ng-template>
</p-toast>

<app-navigation-header></app-navigation-header>

@if(!!(authService.userData$ | async)?.sessionID){
  <div class="main-content">
    <router-outlet />
  </div>

} @else {
  <div class="sign-in">
    <p-card class="sign-in-card">
      @if (isProcessingAuthentication()) {
        <div class="sign-in-loading">
          <p-progressSpinner />
        </div>
      } @else {
        <p class="sign-in-message">Welcome to Web Analytics. Please sign in to continue.</p>
        <p-button icon="pi pi-sign-in" label="Sign in" (onClick)="authService.login()" />
      }
    </p-card>
  </div>
}